export default __webpack_public_path__ + "static/1042-49cd0e2a5ce1ef71efefb08bcd4b26e4.gif";